type SectionType = "card" | "pop-up"

const requestMultipleDeliveriesLinkDataPush = (section:
  SectionType) => {
  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: "button",
        label: "request-delivery",
        action: "start",
        section,
        type: "",
        value: "",
      },
    });
  }
};

export default requestMultipleDeliveriesLinkDataPush;
